import './src/main.css'
import BorderBox13 from './src/main.vue'

export default function (Vue) {
  Vue.component(BorderBox13.name, BorderBox13)
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@jiaminghi/data-view/lib/components/borderBox13/index.js
// module id = null
// module chunks = 